<script>
  import options from './CreateGallery.options'
  export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-create-gallery">

    <section class="kb-stafet-flow-title">

      <h1 class="kb-stafet-flow-title__title">{{ getLabel("title", [groupName]) }}</h1>
      
      <div class="kb-stafet-flow-title__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
      </div>

      <div class="kb-stafet-flow-title__description">
        <p class="kb-stafet-flow-title__description-text">{{ getLabel("description") }}</p>
      </div>

   </section>
    
   <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

     <div class="kb-stafet-step__input-wrapper">

      <FormInputTextField
        fieldName="galleryTitle"
        v-model="galleryTitle"
        :modelValue="galleryTitle.toString()"
        :label='getLabel("galleryTitleLabel")'
        :isRequired="true"
        :isValidationError="galleryTitle === '' && showInputErrors"
        :errorMessageLabel='getLabel("galleryTitleErrorMessage")'
      />

      <div class="kb-create-gallery__texteditor ValidationRequired" :class="galleryContent === '' && showInputErrors ? 'kb-create-gallery__texteditor--error' : ''">
        <label class="Form__Element__Caption">{{ getLabel("galleryContentLabel") }}</label>
        <editor 
        api-key="no-api-key" :init='{
            plugins: "emoticons autoresize lists autolink",
            toolbar: "emoticons bold italic underline bullist numlist link",
            toolbar_location: "bottom",
            menubar: false,
            statusbar: false,
            license_key: "gpl"
          }'
          v-model="galleryContent"
        ></editor>
        <p class="kb-forms Form__Element__ValidationError">{{ getLabel('galleryContentErrorMessage') }}</p>
      </div>

      
      <div class="kb-create-gallery__files" v-if="galleryImages && galleryImages.length > 0">
        <template v-for="image, index in galleryImages" :key="index">
          <div class="kb-create-gallery__files-content-wrapper">
            <div class="kb-create-gallery__files-content-wrapper-left">
              <figure class="kb-create-gallery__files-image kb-image-module">
                <div class="kb-image-module__image-container">
                  <picture class="kb-image-module__image">
                    <img :src="image.url" alt="gallery image" />
                  </picture>
                </div>
              </figure>
            </div>
            <div class="kb-create-gallery__files-content-wrapper-right">
              <div class="kb-create-gallery__files-details-wrapper">
                <p>{{ image.name }}</p>
                <p>{{ getLabel('fileSizeLabel') }}: {{ (image.size / 1024 / 1000).toFixed(3) }} MB</p>
              </div>
              <button class="kb-button kb-button--full-color-spot kb-create-gallery__files-delete-button" v-on:click="() => removeFile(image.name)">{{ getLabel('fileButtonRemove') }}</button>
            </div>
          </div>
        </template>
      </div>
       
      <div class="kb-create-gallery__file-upload" :class="galleryImages && galleryImages.length === 0 && showInputErrors && isGallery ? 'kb-create-gallery__file-upload--error' : ''"> 
        <label class="kb-form__file-upload FormFileUpload" for="galleryImages">
          <input
            class="kb-form__file-upload-input FormFileUpload__Input"
            id="galleryImages"
            type="file"
            accept="image/png, image/jpg, image/jpeg, .svg"
            v-on:change="onFileChange"
          />
          <div class="kb-form__file-upload-svg">
            <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity=".4" fill="#3C3C3C">
                <path
                  d="m20.024 13.05.967-.405-.206-.481c-.84-2.002-.617-4.14.596-5.683 1.214-1.542 3.095-2.264 5.32-2.093l-1.49 1.438.73.75 2.016-1.961a1.008 1.008 0 0 0 0-1.44l-2.016-1.961-.73.75 1.396 1.357c-2.505-.133-4.674.757-6.049 2.518-1.451 1.856-1.72 4.375-.736 6.72l.203.49ZM18.141 24.419v1.046h-5.93v-1.046H.699v2.965a1.214 1.214 0 0 0 1.221 1.22h26.163a1.22 1.22 0 0 0 1.22-1.22v-2.965H18.142Zm10.116 2.965a.174.174 0 0 1-.174.174H1.92a.178.178 0 0 1-.125-.052.175.175 0 0 1-.05-.122v-1.919h9.42v1.047h8.023v-1.047h9.07v1.919ZM4.886 21.977H2.793V9.593a.174.174 0 0 1 .174-.174h14.128V8.372H2.967a1.22 1.22 0 0 0-1.22 1.221v13.43h3.139v-1.046Z"
                />
                <path
                  d="M28.256 23.023V9.593a1.22 1.22 0 0 0-1.22-1.22h-4.013v1.046h4.012a.174.174 0 0 1 .174.174v13.43h1.047Z"
                />
              </g>
            </svg>
          </div>
          <div class="kb-form__file-upload-text-wrapper">
            <p class="kb-form__file-upload-text">
              {{ getLabel("uploadTitle") }}
            </p>
            <small class="kb-form__file-upload-format-types">{{
              getLabel("uploadFormats")
            }}</small>
          </div>
        </label>
        <p class="kb-forms Form__Element__ValidationError">{{ getLabel('galleryContentErrorMessage') }}</p>
      </div>

      </div>
      <nav class="kb-stafet-flow-actions">
        <div class="kb-stafet-flow-actions__buttons-right-wrapper">
            <button
              class="kb-button kb-button--full-color-spot"
              v-on:click="submitCreateGallery"
            >
              {{ content ? getLabel('editButtonLabel') : getLabel("createButtonLabel") }}
            </button> 
        </div>
      </nav>

   </section>

  </article>
</template>

